/**
 * ContainerREADY door kit — DIY vs Complete decision + ATC.
 * Syncs package cards to real Shopify variants. Door always sold separately.
 */
(function () {
  'use strict';

  if (customElements.get('cc-door-package-details')) return;

  function formatMoney(cents, moneyFormat) {
    var amount = (Number(cents) / 100).toFixed(2);
    var format = moneyFormat || '${{amount}}';
    if (format.indexOf('{{amount_no_decimals}}') !== -1) {
      return format.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    if (format.indexOf('{{amount_with_comma_separator}}') !== -1) {
      return format.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    }
    return format.replace('{{amount}}', amount).replace('{{amount_with_currency}}', amount);
  }

  function isPrecutOption(value) {
    var raw = String(value || '').toLowerCase();
    return (
      raw.indexOf('premium') !== -1 ||
      raw.indexOf('pre-cut') !== -1 ||
      raw.indexOf('precut') !== -1 ||
      raw.indexOf('399') !== -1
    );
  }

  function normalizeTier(tier) {
    if (tier === 'premium' || tier === 'precut') return 'precut';
    return 'diy';
  }

  class CcDoorPackageDetails extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.buyAnchor = this.querySelector('[data-cc-door-buy-anchor]');
      this.matchEl = this.querySelector('[data-cc-door-match-confirm]');
      this.pkgButtons = this.querySelectorAll('[data-cc-door-pkg]');
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';

      this._onVariantChange = this.onVariantChange.bind(this);
      this._onPkgClick = this.onPkgClick.bind(this);
      document.addEventListener('product:variant-change', this._onVariantChange);

      Array.prototype.forEach.call(this.pkgButtons, function (btn) {
        btn.addEventListener('click', this._onPkgClick);
      }, this);

      var self = this;
      function boot() {
        self.hideNativeDoorPicker();
        self.adoptBuyForm();
      }
      boot();
      window.requestAnimationFrame(boot);
      window.setTimeout(boot, 0);
      window.setTimeout(boot, 250);

      this.applyTier(this.resolveTierFromDom());
    }

    disconnectedCallback() {
      document.removeEventListener('product:variant-change', this._onVariantChange);
      Array.prototype.forEach.call(this.pkgButtons || [], function (btn) {
        btn.removeEventListener('click', this._onPkgClick);
      }, this);
    }

    resolveTierFromDom() {
      var attr = normalizeTier(this.getAttribute('data-active-tier') || 'diy');
      var checked = document.querySelector(
        '#variant-selects-' + this.sectionId + ' input[type="radio"]:checked'
      );
      if (checked) return isPrecutOption(checked.value) ? 'precut' : 'diy';
      return attr;
    }

    hideNativeDoorPicker() {
      if (!this.sectionId) return;
      var picker = document.getElementById('variant-selects-' + this.sectionId);
      if (!picker) return;
      picker.classList.add('cc-door-variant-selects--hidden');
      picker.setAttribute('data-cc-door-picker-hidden', 'true');
    }

    onPkgClick(event) {
      var btn = event.currentTarget;
      if (!btn) return;
      var tier = normalizeTier(btn.getAttribute('data-cc-door-pkg') || 'diy');
      var variantId = btn.getAttribute('data-variant-id');
      this.selectVariant(variantId, tier);
    }

    findPackageRadio(tier) {
      var picker = document.getElementById('variant-selects-' + this.sectionId);
      if (!picker) return null;
      var wantPrecut = normalizeTier(tier) === 'precut';
      var radios = picker.querySelectorAll('input[type="radio"]');
      var match = null;
      Array.prototype.forEach.call(radios, function (input) {
        var precut = isPrecutOption(input.value);
        if (wantPrecut && precut) match = input;
        if (!wantPrecut && !precut && !match) match = input;
      });
      return match;
    }

    selectVariant(variantId, tier) {
      tier = normalizeTier(tier);
      if (!variantId) {
        this.applyTier(tier);
        return;
      }

      var picker = document.getElementById('variant-selects-' + this.sectionId);
      var radio = this.findPackageRadio(tier);

      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('input', { bubbles: true }));
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        if (picker) picker.dispatchEvent(new Event('change', { bubbles: true }));
      }

      var forms = document.querySelectorAll(
        '#ProductInfo-' + this.sectionId + ' form[action*="/cart/add"], form[data-type="add-to-cart-form"]'
      );
      Array.prototype.forEach.call(forms, function (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = variantId;
          input.disabled = false;
        }
      });
      if (this.buyAnchor) {
        var localInput = this.buyAnchor.querySelector('input[name="id"]');
        if (localInput) {
          localInput.value = variantId;
          localInput.disabled = false;
        }
      }

      var priceAttr = tier === 'precut' ? this.dataset.premiumPrice : this.dataset.diyPrice;
      this.applyTier(tier, variantId, priceAttr);
    }

    onVariantChange(event) {
      var detail = event && event.detail ? event.detail : {};
      if (String(detail.sectionId) !== String(this.sectionId)) return;
      var variant = detail.variant;
      if (!variant) return;

      var tier = isPrecutOption(variant.option1 || variant.title) ? 'precut' : 'diy';
      var id = String(variant.id || '');
      if (id && id === String(this.dataset.premiumVariantId || '')) tier = 'precut';
      if (id && id === String(this.dataset.diyVariantId || '')) tier = 'diy';
      this.applyTier(tier, id, variant.price);
    }

    applyTier(tier, _variantId, priceCents) {
      var next = normalizeTier(tier);
      this.setAttribute('data-active-tier', next);

      Array.prototype.forEach.call(this.pkgButtons || [], function (btn) {
        var btnTier = normalizeTier(btn.getAttribute('data-cc-door-pkg'));
        var isOn = btnTier === next;
        btn.classList.toggle('is-selected', isOn);
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
      });

      if (this.matchEl) {
        this.matchEl.textContent = 'Same ContainerREADY kit · pick your door later';
      }
    }

    adoptBuyForm() {
      if (!this.buyAnchor || !this.sectionId) return;
      if (this.buyAnchor.querySelector('product-form')) return;

      var form =
        document.querySelector('#ProductInfo-' + this.sectionId + ' product-form') ||
        document.querySelector('product-form[data-section="' + this.sectionId + '"]');
      if (!form || form.parentNode === this.buyAnchor) return;

      var previousParent = form.parentElement;
      this.buyAnchor.appendChild(form);

      if (
        previousParent &&
        !previousParent.querySelector('product-form') &&
        !previousParent.querySelector('pickup-availability') &&
        !previousParent.querySelector('cc-door-package-details') &&
        !previousParent.querySelector('cc-window-package-details')
      ) {
        previousParent.setAttribute('data-cc-window-buy-shell', 'empty');
      }
    }
  }

  customElements.define('cc-door-package-details', CcDoorPackageDetails);
})();
